import isFunction from 'lodash/isFunction';
import {
  postApiFormWorkflowRequestFormWorkflowList,
  getApiFormWorkflowGetFormWorkflowByIdFormWorkflowId,
} from 'endpoints';
import {
  FormWorkflowListParams,
  FormWorkflowRow,
} from 'pages/Dashboard/pages/Forms/pages/FormWorkflow/types';
import {
  normalizeFormWorkflows,
} from 'pages/Dashboard/pages/Forms/pages/FormWorkflow/normalize';
import compact from 'lodash/compact';
import {
  MediaOriginatorType,
} from 'pages/Dashboard/utils/constants';
import {
  serializeDateRange,
} from 'pages/Dashboard/transport/dateRange';

export async function getFormWorkflowsData({
  pagination,
  dateRange,
  setTotalSize,
  requestMedia,
  filterQuery,
  searchQuery,
}: FormWorkflowListParams): Promise<FormWorkflowRow[]> {
  const response = await postApiFormWorkflowRequestFormWorkflowList({
    includeReferencedObjects: true,
    patientSearchText: searchQuery,
    dateRange: serializeDateRange(dateRange),
    filterQuery,
    pageRequest: {
      page: pagination?.pageIndex ?? 0,
      pageSize: pagination?.pageSize ?? 25,
    },
  });

  if (isFunction(requestMedia)) {
    const patientIds = response.formWorkflows?.data?.map(({ patientId }) => Number(patientId)) ?? [];
    const userIds = compact(response.formWorkflows?.data?.flatMap((item) => [
      item.assignedClinicianUserId,
      item.initiatedByUserId,
    ]) ?? []);
    if(patientIds.length > 0){
      requestMedia(patientIds);
    }
    if (userIds.length > 0) {
      requestMedia(userIds, MediaOriginatorType.User);
    }
  }

  const meta = response.formWorkflows?.pageProperties;
  setTotalSize(meta?.totalSize ?? 0);

  return normalizeFormWorkflows({ response });
}

export async function getFormWorkflowDetail(formWorkflowId: number) {
  return getApiFormWorkflowGetFormWorkflowByIdFormWorkflowId(formWorkflowId, {
    includeReferencedObjects: true,
  });
}
